import React, { useEffect, useState } from "react";
import "./MessageCentre.css";
import { useDispatch, useSelector } from "react-redux";
import DataTableComponent from "../../components/DataTable";
import Loader from "../../components/Common/Loader/PrimaryLoader";
import {
  deleteMessageCenterData,
  fetchMessageCentreData,
} from "../../redux/slice/MessageCentreSlice";
import { RxTriangleDown } from "react-icons/rx";
import DeleteConFirmationModal from "../../components/Common/DeleteConFirmationModal";
import { useNavigate } from "react-router-dom";
import { usePic } from "../../context/PicProvider";

function MessageCentre() {
  const dispatch = useDispatch();
  const { setIsLoading } = usePic();
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [modalConfirmTitle, setModalConfirmTitle] = useState("");
  const [customClass, setCustomClass] = useState("");
  const [showDropCon, setShowDropCon] = useState(false);
  const [downDrop, setDownDrop] = useState(false);
  const [removeId, setRemoveId] = useState([]);

  const { status, MessageCentreData } = useSelector(
    (state) => state.MESSAGECENTRE
  );

  const navigate = useNavigate();

  const handleCustomClassForUnderLine = (num) => {
    setCustomClass(num);
  };

  const downIconHandler = () => {
    setDownDrop(!downDrop);
  };

  const deleteHandler = () => {
    setDeleteConfirm(true);
    setModalConfirmTitle("Are you sure you want to delete this notification?");
  };

  const removeMessageHandler = async () => {
    setIsLoading(true);
    const data = { ids: removeId };
    const res = await dispatch(deleteMessageCenterData(data));
    setIsLoading(false);
    if (res?.payload?.status === 200) {
      navigate("/messaging");
      dispatch(fetchMessageCentreData());
      setDeleteConfirm(false);
      setShowDropCon(false);
      setDownDrop(false);
      setRemoveId([]);
    }
  };

  const onSelectedCheckboxChange = (data) => {
    const selectedIds = data?.selectedRows.map((curElm) => curElm._id);
    if (selectedIds.length > 0) {
      setRemoveId(selectedIds);
      setShowDropCon(true);
    } else {
      setRemoveId([]);
      setShowDropCon(false);
    }
  };

  useEffect(() => {
    dispatch(fetchMessageCentreData());
  }, [dispatch]);

  const Messagecolumns = [
    {
      name: (
        <span
          className={customClass === "1" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("1")}
        >
          {" "}
          Subject
        </span>
      ),
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "2" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("2")}
        >
          Category
        </span>
      ),
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "4" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("4")}
        >
          Scheduled
        </span>
      ),
      selector: (row) => new Date(row.publish_on).toLocaleDateString(),
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "5" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("5")}
        >
          Status
        </span>
      ),
      selector: (row) => {
        let statusContent = row?.status?.toLowerCase();
        let statusColor = "";
        switch (statusContent) {
          case "completed":
            statusColor = "#359742";
            statusContent = "Published";
            break;
          case "scheduled":
            statusColor = "#CCA300";
            break;
          case "approved":
            statusColor = "#CCA300";
            break;
          case "pending":
            statusColor = "#CCA300";
            statusContent = "Pending Approval";
            break;
          case "cancelled":
            statusColor = "#FF6666";
            statusContent = "Draft";
            break;
          default:
            statusColor = "#FF6666";
            break;
        }
        return (
          <span
            className={`status ${statusColor} text-capitalize`}
            style={{ color: statusColor }}
          >
            {statusContent}
          </span>
        );
      },
      sortable: true,
    },
  ];
  if (status === "loading") {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  const userData = MessageCentreData || [];

  const onRowClickHandler = (values) => {
    navigate(`/edit-notification`, {
      state: {
        id: values._id,
      },
    });
  };

  return (
    <div className=" position-relative flex-grow-1">
      {userData && userData.length > 0 && showDropCon && (
        <div className="dropdown_icon_style">
          <div onClick={() => downIconHandler()}>
            <RxTriangleDown size={23} />
          </div>
          {downDrop && (
            <div className="event-box-data-user-event-listing">
              <h6 className="cursor" onClick={() => deleteHandler()}>
                Delete{" "}
              </h6>
            </div>
          )}
        </div>
      )}
      <DataTableComponent
        search={false}
        searchBy={["title", "category", "type"]}
        title={"Notifications Centre"}
        columns={Messagecolumns}
        data={userData}
        selectedRows
        checkboxChange={onSelectedCheckboxChange}
        clickedRow={onRowClickHandler}
      />
      {deleteConfirm && (
        <DeleteConFirmationModal
          show={deleteConfirm}
          title={modalConfirmTitle}
          eventHandler={removeMessageHandler}
          hide={() => setDeleteConfirm(false)}
        />
      )}
    </div>
  );
}

export default MessageCentre;
